import { AppState } from 'store/reducer';

export const paymentsSelector = ({ usersActivities: { loading, data, query, pagination } }: AppState) => ({
  loading,
  data,
  query,
  pagination,
});
